import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

const AnimatedLayer = styled.img`
	position: absolute;
	height: 100%;
	top: 0;
	opacity: 0;
`

const WachstumStarten = ({ play }) => {
	const leafs = useRef(false);

	const layers = [];
	for (let n = 1; n <= 38; n++) {
		layers.push(<AnimatedLayer key={`leaf-${n}`} src={`/assets/cover/leaf-${n}.png`}/>)
	}

	useEffect(() => {
		anime({
			targets: leafs.current.children,
			easing: 'easeInOutElastic(1, .6)',
			opacity: 1,
			delay: anime.stagger(50),
			autoplay: play,
			loop: true,
			direction: 'alternate'
		});
	}, [play])
	return (
		<>
			<div ref={leafs}>
				{ layers }
			</div>
		</>
	)
};

export default WachstumStarten;